import helpers from '../helpers';

function getPadding(block, padding) {
	return Number(window.getComputedStyle(block, null).getPropertyValue(padding).replace('px', ''));
}

const scrollContainer = document.getElementById('fullpage');
let firstScroll = true;
let allSection;
let innerScrollBlock;
let innerScrollWrapper;
const menuItem = document.querySelectorAll('.header__link');
let heightBlock;
let heightWrapper;
let paddingBlockTop;
let paddingBottom;
let heightDifference;
const touchpadDeadZone = 10;
let height = window.innerHeight;
let speed = 500;
let pause = speed + 50;
let activeSection = 0;
let lastSectionOffSetBottom = false;
let isPause = false;
let scrollLock = false;
let transformValue = 0;
let checkScrollUp = true;
let checkScrollDown = true;
let tarnsformSpeed = 50;
let noInnerScroll = false;

function addClassHeader(endFullPage) {
	const header = helpers.$header[0];
	if (endFullPage) {
		header.classList.add('with-bg');
	} else {
		header.classList.add('light');
	}
}

function removeClassHeader() {
	const header = helpers.$header[0];
	header.classList.remove('light');
	header.classList.remove('with-bg');
}

function toggleActiveMenu() {
	if (activeSection === 3) {
		menuItem.forEach((el) => {
			el.classList.remove('header__link--active');
			if (el.classList.contains('js-to-anchor')) {
				el.classList.add('header__link--active');
			}
		});
	} else {
		menuItem.forEach((el, index) => {
			el.classList.remove('header__link--active');
			if (index === 0) {
				el.classList.add('header__link--active');
			}
		});
	}
}

function toggleClassHeader() {
	if (allSection[activeSection].classList.contains('main__nominations')) {
		addClassHeader(false);
	} else {
		removeClassHeader();
	}
}

function scrollUp() {
	if (activeSection !== 0) {
		helpers.scrollTo($(allSection[activeSection - 1]), speed);

		if (activeSection >= 0) {
			activeSection -= 1;
		}

		toggleClassHeader();
	}
}

function scrollDown() {
	if ($(allSection[activeSection + 1])[0]) {
		helpers.scrollTo($(allSection[activeSection + 1]), speed);
		activeSection += 1;

		toggleClassHeader();
	} else {
		helpers.scrollTo($(allSection[activeSection]), speed, height);
		addClassHeader(true);

		setTimeout(() => {
			lastSectionOffSetBottom = $(allSection[activeSection]).offset().top + height;
		}, 600);
	}
}

function stopAnim(ms) {
	isPause = true;

	setTimeout(() => {
		isPause = false;
	}, ms);
}

function checkInnerScroll() {
	if (allSection[activeSection].id === 'stages' && !noInnerScroll) {
		scrollLock = true;
		checkScrollDown = false;
		checkScrollUp = false;
	}
}

function setValueDisplay() {
	if (noInnerScroll) {
		innerScrollBlock.style.justifyContent = 'center';
	} else {
		innerScrollBlock.style.justifyContent = 'flex-start';
	}
}

function checkHeightScrollBlock() {
	if (heightDifference <= 0) {
		scrollLock = false;
		noInnerScroll = true;
	} else {
		noInnerScroll = false;
	}

	setValueDisplay();
}

function setTransformValue(e) {
	if (e.deltaY < tarnsformSpeed) {
		transformValue += e.deltaY * tarnsformSpeed;
	} else {
		transformValue += e.deltaY;
	}
}

function resrtDirectionScroll() {
	checkScrollUp = true;
	checkScrollDown = true;
}

function scrollAffterInnerScroll() {
	if (transformValue <= 0) {
		stopAnim(pause);
		checkScrollUp = true;
		scrollLock = false;
	} else if (heightDifference <= transformValue) {
		stopAnim(pause);
		checkScrollDown = true;
		scrollLock = false;
	}
}

function innerScroll(e) {
	setTransformValue(e);

	if (heightDifference <= 0) {
		scrollLock = false;
		noInnerScroll = true;
	} else {
		if (e.deltaY > touchpadDeadZone) {
			if (heightDifference > transformValue) {
				innerScrollWrapper.style.transform = `translateY(${-transformValue}px)`;
			} else {
				transformValue = heightDifference;
				innerScrollWrapper.style.transform = `translateY(${-transformValue}px)`;
				scrollAffterInnerScroll();
			}
		} else if (e.deltaY < -touchpadDeadZone) {
			if (transformValue >= 0) {
				innerScrollWrapper.style.transform = `translateY(${-transformValue}px)`;
			} else {
				transformValue = 0;
				innerScrollWrapper.style.transform = `translateY(${transformValue}px)`;
				scrollAffterInnerScroll();
			}
		}
		noInnerScroll = false;
	}
}

function fullpageScroll(e) {
	if (!isPause && !scrollLock) {
		if (e.deltaY > touchpadDeadZone && checkScrollDown) {
			scrollDown();
		} else if (e.deltaY < -touchpadDeadZone && checkScrollUp) {
			scrollUp();
		}

		stopAnim(pause);
		resrtDirectionScroll();
		checkInnerScroll();
	} else if (!isPause && scrollLock) {
		innerScroll(e);
	}
	toggleActiveMenu();
}

function scrollToLastSection() {
	if (window.pageYOffset < lastSectionOffSetBottom && !isPause) {
		helpers.scrollTo($(allSection[activeSection]));
		lastSectionOffSetBottom = false;
		removeClassHeader();
	}
}

function setActiveSection() {
	allSection.forEach((el, index) => {
		if (el.getBoundingClientRect().top >= 0 && el.getBoundingClientRect().top < window.innerHeight - 10) {
			activeSection = index;

			if (activeSection !== 0) {
				helpers.$header[0].classList.add('header--fixed');
			}
		}
	});
}

function updateProperty() {
	heightBlock = innerScrollBlock.getBoundingClientRect().height;
	heightWrapper = innerScrollWrapper.clientHeight;
	paddingBlockTop = getPadding(innerScrollBlock, 'padding-top');
	paddingBottom = getPadding(innerScrollBlock, 'padding-bottom');
	heightDifference = heightWrapper - heightBlock + paddingBlockTop + paddingBottom;

	checkHeightScrollBlock();
}

function init() {
	if (!helpers.isMobile() && scrollContainer) {
		allSection = scrollContainer.querySelectorAll('.section');
		innerScrollBlock = document.getElementById('stages').querySelector('.main-page__about-content');
		innerScrollWrapper = innerScrollBlock.querySelector('.main-page__about-content-wrapper');
		heightBlock = innerScrollBlock.getBoundingClientRect().height;
		heightWrapper = innerScrollWrapper.clientHeight;
		paddingBlockTop = getPadding(innerScrollBlock, 'padding-top');
		paddingBottom = getPadding(innerScrollBlock, 'padding-bottom');
		heightDifference = heightWrapper - heightBlock + paddingBlockTop + paddingBottom;

		checkHeightScrollBlock();
		setActiveSection();
		toggleClassHeader();
		toggleActiveMenu();
		scrollContainer.addEventListener('wheel', (e) => {
			e.preventDefault();
			if (!isPause) {
				fullpageScroll(e);
			}
		});

		window.addEventListener('scroll', () => {
			scrollToLastSection();

			if (firstScroll) {
				setTimeout(() => {
					setActiveSection();
					toggleClassHeader();
					toggleActiveMenu();
					checkInnerScroll();
					firstScroll = false;
				}, 400);
			}
		});

		window.addEventListener('resize', updateProperty);
	}
}

export default {
	init,
	scrollDown,
	setActiveSection,
	toggleActiveMenu,
	checkInnerScroll,
};
